<template>
  <div class="auth">
    <div class="dot_">
      <img src="../../../assets/image/nsale/dot.svg" alt="">
    </div>
    <p class="result_">{{isPass == '1' ? '认证成功！' : isPass == '5' ? '认证中' : '认证失败！'}}</p>
    <p class="title_" v-if="isPass == '1'">恭喜您，认证成功！！</p>
    <p class="title_" v-else-if="isPass == '5'">您的信息已提交，将在7个工作日内返回认证结果，请耐心等待</p>
    <p class="title_" v-else>
      未匹配到您的保险执业从业资质！请您核对信息是否无误，重新进行认证。您也可以联系您的客户经理或平台运营寻求解决方案。
    </p>
    <div>
      <cube-button class="backbtn_" @click="back">返回</cube-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    document.title = '认证结果'
    return {
      isPass: ''
    }
  },
  created() {
    let { isPass } = this.$route.query
    this.isPass = isPass
  },
  mounted() {
    // 禁用浏览器的返回 不能返回上一页重复进行资质认证
    window.history.pushState(null, null, document.URL);
    window.addEventListener('popstate', function () {
      window.history.pushState(null, null, document.URL);
    });
  },
  methods: {
     back() {
        let origin = "http://wx.run4wd.com";
        if (/ssish/.test(location.href)||/yutai365/.test(location.href)) {
          origin = "http://wx.ssish.com"
        }
        window.location.href = `${origin}/my/personalCenter/personalCenter`
      }
    }
}
</script>

<style lang="scss" scoped>
.auth {
  width: 100%;
  padding: 30px 20px 0;
  .dot_ {
    display: flex;
    justify-content: flex-start;
    img {
      width: 27px;
      height: 20px;
    }
  }
  .result_ {
    font-size: 30px;
    color: #333;
    font-weight: 800;
    text-align: left;
    margin: 15px 0;
  }
  .title_ {
    color: #999999;
    font-size: 13px;
    line-height: 30px;
    text-align: left;
    margin-bottom: 25px;
  }
  .backbtn_ {
    border-radius: 14px;
    background: linear-gradient(45deg, #FF7C6C 0%, #FFA297 100%);
    
  }
}
</style>
